import { createContext, type ReactNode, useEffect, useState } from 'react';

import { toast } from '@/components/Toaster/Toast';

import { sensorService } from '@/controllers/sensorService';

import type { Maybe } from '@/types/Maybe';

interface IScreen {
  id: number | string;
  title: string;
}

export interface ISessionScreenStoreContextValue {
  currentScreen: Maybe<IScreen>;
  goToScreen: (id: number | string) => void;
  goToNextScreen: VoidFunction;
  goToPreviousScreen: VoidFunction;
}

export const SessionScreenStore = createContext<Maybe<ISessionScreenStoreContextValue>>(null);

export const SessionScreenContextProvider = ({ children }: { children: ReactNode }) => {
  const screens: IScreen[] = [
    {
      id: 0,
      title: 'Hub Connect',
    },
    {
      id: 1,
      title: 'Sensors',
    },
    {
      id: 2,
      title: 'Recording',
    },
    {
      id: 3,
      title: 'Process and Upload',
    },
    {
      id: -1,
      title: 'Recalibrate',
    },
  ];
  const [currentScreen, setCurrentScreen] = useState<IScreen>(screens[0]);

  const goToScreen = (id: number | string) => {
    if (typeof id === 'string') {
      const match = screens.findIndex((screen) => screen.title === id);
      if (screens.at(match)) {
        return setCurrentScreen(screens[match]);
      }
    }

    const match = screens.findIndex((screen) => screen.id === id);
    if (screens.at(match)) {
      return setCurrentScreen(screens[match]);
    }
  };

  const goToNextScreen = () => {
    const match = screens.findIndex((screen) => screen.id === currentScreen?.id);
    if (screens.at(match + 1)) {
      return setCurrentScreen(screens[match + 1]);
    }
  };

  const goToPreviousScreen = () => {
    const match = screens.findIndex((screen) => screen.id === currentScreen?.id);
    if (screens.at(match - 1)) {
      return setCurrentScreen(screens[match - 1]);
    }
  };

  return (
    <SessionScreenStore.Provider
      value={{
        goToScreen,
        currentScreen,
        goToNextScreen,
        goToPreviousScreen,
      }}>
      {children}
    </SessionScreenStore.Provider>
  );
};
